import React from 'react';
import { ShieldCheckIcon, StarIcon, MapPinIcon, AwardIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col justify-center pt-20" data-id="element-120">
      {/* Parallax Background */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/riKQHpWH1XPRagWSfsMxYT/black-and-white-designing-sNwHCsDAT1c-unsplash.jpg")',
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-121">
        {/* Gradient Overlay for text readability */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(28,40,86,0.85) 0%, rgba(28,40,86,0.78) 50%, rgba(28,40,86,0.88) 100%)'
      }} data-id="element-122" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 max-w-5xl text-center flex-grow flex flex-col justify-center py-12 md:py-24" data-id="element-123">
        <h1 className="font-heading text-[34px] md:text-6xl lg:text-7xl font-extrabold italic text-white uppercase tracking-tight mb-6 leading-tight" style={{
        textShadow: '2px 2px 8px rgba(0,0,0,0.5), 0 4px 16px rgba(0,0,0,0.3)'
      }} data-id="element-124">
          Spotless Floors.{' '}
          <span className="relative inline-block" data-id="element-125">
            Guaranteed.
            <span className="absolute left-0 bottom-0 w-full h-[4px] rounded-full" style={{
            backgroundColor: '#C41E2A'
          }} data-id="element-126" />
          </span>
        </h1>
        <p className="text-[16px] md:text-xl text-white font-light max-w-3xl mx-auto mb-10 leading-relaxed" style={{
        textShadow: '0 1px 4px rgba(0,0,0,0.4)'
      }} data-id="element-127">
          Professional carpet, tile & grout cleaning for Phoenix homes and
          businesses. Truck-mounted equipment. Locally owned. 5-star rated.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto px-4 sm:px-0" data-id="element-128">
          <Button variant="primary" size="lg" fullWidth className="sm:w-auto sm:min-w-[240px]" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-129">
            Schedule Appointment
          </Button>
          <Button variant="secondary" size="lg" fullWidth className="sm:w-auto sm:min-w-[240px]" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-130">
            Call (602) 935-1141
          </Button>
        </div>
      </div>

      {/* Trust Strip */}
      <div className="relative z-10 bg-white/95 backdrop-blur-sm border-t border-silver py-4 md:py-6 w-full mt-auto" data-id="element-131">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-132">
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-sm md:text-base font-semibold text-navy" data-id="element-133">
            <div className="flex items-center gap-2" data-id="element-134">
              <ShieldCheckIcon className="text-red" size={24} data-id="element-135" />
              <span data-id="element-136">HomeAdvisor Approved</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-137">
              <StarIcon className="text-red fill-red" size={24} data-id="element-138" />
              <span data-id="element-139">5-Star Google Reviews</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-140">
              <MapPinIcon className="text-red" size={24} data-id="element-141" />
              <span data-id="element-142">Locally Owned & Operated</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-143">
              <AwardIcon className="text-red" size={24} data-id="element-144" />
              <span data-id="element-145">Licensed & Insured</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}